import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentKey, AgentOption } from '../agentic-ecommerce.types';

@Component({
  selector: 'app-agentic-agent-selector',
  templateUrl: './agent-selector.component.html',
  styleUrls: ['./agent-selector.component.css'],
})
export class AgentSelectorComponent {
  @Input() agents: AgentOption[] = [];
  @Input() selectedAgentKey: AgentKey = '';

  @Output() agentSelected = new EventEmitter<AgentKey>();

  public selectAgent(agentKey: AgentKey): void {
    const agent = this.agents.find((option) => option.key === agentKey);

    if (!agent || agent.disabled) {
      return;
    }

    this.agentSelected.emit(agentKey);
  }

  // Store's lead over the benchmarked competitor for this agent (score points).
  // 0 when there's no comparable competitor data.
  public getLead(agent: AgentOption): number {
    if (agent.disabled || !agent.competitor || agent.competitor.disabled) {
      return 0;
    }
    return agent.score - agent.competitor.score;
  }

  public getLeadArrow(agent: AgentOption): string {
    const lead = this.getLead(agent);
    return lead > 0 ? '▲' : lead < 0 ? '▼' : '—';
  }

  public getLeadLabel(agent: AgentOption): string {
    const lead = this.getLead(agent);
    return lead > 0 ? `+${lead}` : `${lead}`;
  }

  public trackByAgent(index: number, agent: AgentOption): AgentKey {
    return agent.key || String(index);
  }
}
